exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info[data-v-15f27072] {\n  background-color: #efefef;\n}\n.title-box[data-v-15f27072] {\n  margin-left: 20px;\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 10px;\n  position: relative;\n}\n.title-box[data-v-15f27072]::before {\n  content: \" \";\n  background-color: #22c655;\n  width: 4px;\n  height: 100%;\n  border-radius: 1px;\n  position: absolute;\n  left: -10px;\n}", ""]);

// exports
